import React, {Component} from 'react';
import {Grid} from 'semantic-ui-react';
import {
  resources,
  scopes,
} from '../../../../../common/permissions/dictionary';
import {hasAccessPermission} from '../../../../../common/permissions/validations';

class PartPrice extends Component {
  renderNumericValue(width, value = 0) {
    return <Grid.Column width={width}>{value}</Grid.Column>;
  }

  renderMoneyValue(width, value) {
    const money = value || 0;
    return this.renderNumericValue(width, `$${money.toFixed(2)}`);
  }

  renderLabel(width, label, paddingLeft) {
    const classes = paddingLeft ? 'padding-left' : '';
    return (
      <Grid.Column width={width} className={classes}>
        <span className='bolder'>{label}</span>
      </Grid.Column>
    );
  }

  render() {
    const {data, permissions} = this.props;
    return hasAccessPermission(permissions, resources.PartPrices, scopes.See) && (
      <Grid columns='equal' className='border-bottom padding-bottom'>
        <Grid.Row>
          {this.renderLabel(3, 'Wholesale')}
          {this.renderMoneyValue(5, data.pvpToyotaEcuador)}
          {this.renderLabel(2, 'Costo')}
          {this.renderMoneyValue(6, data.cost)}
        </Grid.Row>
        <Grid.Row>
          {this.renderLabel(3, 'Retail')}
          {this.renderMoneyValue(5, data.pvp)}
          {this.renderLabel(2, 'FOB')}
          {this.renderMoneyValue(6, data.fob)}
        </Grid.Row>
      </Grid>
    );
  }
}

export default PartPrice;
